import { Graphic2DDynamicVIBuffer } from "../../display/Scene2DSpecial/Graphic2DDynamicVIBuffer";
import { VertexDeclaration } from "../../RenderEngine/VertexDeclaration";
import { VertexElement } from "../../renders/VertexElement";
import { VertexElementFormat } from "../../renders/VertexElementFormat";
export class GraphicsMesh {
    static __init__() {
        GraphicsMesh.vertexDeclarition = new VertexDeclaration(64, [
            new VertexElement(0, VertexElementFormat.Vector4, 0),
            new VertexElement(16, VertexElementFormat.Vector4, 1),
            new VertexElement(32, VertexElementFormat.Vector4, 2),
            new VertexElement(48, VertexElementFormat.Vector4, 3),
        ]);
        GraphicsMesh.stride = GraphicsMesh.vertexDeclarition.vertexStride / 4;
    }
    get bufferState() {
        return this._buffer.bufferState;
    }
    constructor() {
        this._buffer = new Graphic2DDynamicVIBuffer(4, GraphicsMesh.vertexDeclarition);
    }
    checkVertex(vertexCount) {
        let vbResult = this._buffer.checkVertexBuffer(vertexCount);
        if (!vbResult)
            return null;
        return {
            mesh: this,
            vertexBlocks: vbResult.vertexBlocks,
            vertexViews: vbResult.vertexViews
        };
    }
    checkIndex(indexCount) {
        return this._buffer.checkIndexBuffer(indexCount);
    }
    clearBlocks(vertexBlocks) {
        this._buffer.releaseVertexBlocks(vertexBlocks);
    }
    clearIndexView(indexView) {
        this._buffer.releaseIndexView(indexView);
    }
    clear() {
        this._buffer.clear();
    }
    destroy() {
        this._buffer.destroy();
        this._buffer = null;
    }
}
GraphicsMesh.stride = 0;
